import { render, staticRenderFns } from "./SliderEditor.vue?vue&type=template&id=4ab5d1db&scoped=true&"
import script from "./SliderEditor.vue?vue&type=script&lang=js&"
export * from "./SliderEditor.vue?vue&type=script&lang=js&"
import style0 from "./SliderEditor.vue?vue&type=style&index=0&id=4ab5d1db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab5d1db",
  null
  
)

export default component.exports